'use client';

import { type JSX, useEffect } from 'react';

const DISMISS_AFTER_MS = 3000;

interface FeedbackConfirmationProps {
    onDismiss: () => void;
}

export function FeedbackConfirmation({ onDismiss }: FeedbackConfirmationProps): JSX.Element {
    useEffect(() => {
        const timer = setTimeout(onDismiss, DISMISS_AFTER_MS);
        return (): void => clearTimeout(timer);
    }, [onDismiss]);

    return <p className="text-center text-xs text-gray-600">Thanks for your feedback!</p>;
}
